import { Input, Modal } from 'antd';
import { MODAL_NAME } from 'constants/modal';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { closeModal } from 'store/reducers/modal';
import { WarningOutlined } from '@ant-design/icons';

const PopupRunTest = ({ isPageApprove }) => {
  const { open, data } =
    useSelector((state) => state.modal[MODAL_NAME.RUN_TEST]) || {};
  const dispatch = useDispatch();
  const [test, setTest] = useState();
  const { inputTest } = data || {};

  useEffect(() => {
    setTest(inputTest);
    // eslint-disable-next-line
  }, [open]);

  const close = () => {
    dispatch(closeModal({ name: MODAL_NAME.RUN_TEST }));
  };

  const onChangeInputTest = (e) => {
    setTest(e.target.value);
  };

  return (
    <Modal
      okText="Run"
      open={open}
      onCancel={close}
      title="Run Test"
      className="run-sample"
    >
      {!isPageApprove && (
        <div className="desc">
          <WarningOutlined /> Make sure you save it before you can test this
          code.
        </div>
      )}
      <div className="run-sample__block">
        <label className="run-sample__label">Input</label>
        <Input.TextArea value={test} onChange={onChangeInputTest} rows={10} />
      </div>
      <div className="run-sample__block">
        <label className="run-sample__label">Output</label>
        <Input.TextArea disabled contentEditable={false} rows={10} />
      </div>
    </Modal>
  );
};

export default PopupRunTest;
